import styled, { css } from 'styled-components';
var PageContentWrapper = styled.div.withConfig({
  displayName: "PageContentWrapper",
  componentId: "pokv52-0"
})(["min-height:100%;width:100%;", " ", ";", ""], function (_ref) {
  var bgStart = _ref.bgStart;
  return bgStart && css(["background-color:", ";"], bgStart);
}, function (_ref2) {
  var bgStart = _ref2.bgStart,
      bgEnd = _ref2.bgEnd;
  return bgStart && bgEnd && css(["background-image:", ";"], "linear-gradient(to bottom, " + bgStart + " 0, " + bgEnd + " 100%)");
}, function (_ref3) {
  var customBg = _ref3.customBg;
  return customBg && css(["position:relative;z-index:1;"]);
});
export default PageContentWrapper;